<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="SerialVault" title="Serial Mark It Sold" />
        <v-container fluid>
          <table class="center">
            <!-- <v-divider class="mx-3"></v-divider> -->
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table
                  :loading="localLoading"
                  dense
                  sort-by="name"
                  :mobile-breakpoint="0"
                  :headers="headers"
                  :itemsPerPage="SerialVault.length"
                  hide-default-footer
                  :items="SerialVault"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        {{ item.createdAt | moment("MM/DD/YYYY") }}
                      </td>
                      <td class="text-left text-capitalize">
                        <span v-if="item.User">{{ item.User.name }}</span>
                      </td>
                      <td class="text-center">{{ item.message }}</td>
                      <td class="text-left">
                        <span
                          v-if="
                            item.SerialVault &&
                            item.SerialVault.Product &&
                            item.SerialVault.Product.name
                          "
                          >{{ item.SerialVault.Product.name }}</span
                        >
                      </td>
                      <td class="text-right">{{ item.imeiNumber }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import reportService from "@/modules/ReportView/service.js";

import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      expanded: [],
      localLoading: false,
      showEmailBtn: false,
      total: 0,
      isLoading: true,
      SerialVault: null,
      start: null,
      end: null,
      headers: [
        {
          text: "Created At",
          align: "left",
          value: "createdAt",
          sortable: false,
          width: "20%",
        },
        {
          text: "User",
          align: "left",
          value: "User.name",
          sortable: false,
        },
        {
          text: "Description",
          align: "center",
          value: "message",
          sortable: false,
          width: "30%",
        },
        {
          text: "PRODUCT NAME",
          align: "left",
          value: "SerialVault.Product.name",
          sortable: true,
        },
        {
          text: "Serial Number",
          align: "right",
          value: "imeiNumber",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  created() {
    this.start = this.$route.query.start;
    this.end = this.$route.query.end;
    this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  components: {
    ReportViewBar,
  },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    loadData() {
      this.localLoading = true;
      return reportService
        .getMarkItSoldSerial({ start: this.start, end: this.end })
        .then((response) => {
          this.$Progress.finish();
          this.SerialVault = response.data;

          this.isLoading = false;
          this.localLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
